import {combineReducers} from 'redux';
import authReducer from './auth.reducer';
import chatReducer from './chat.reducer';
import journeyReducer from './journey.reducer';
import bookingReducer from './booking.reducer';
import socialReducer from './social.reducer';
import adminReducer from './admin.reducer';

const rootReducer = combineReducers({
  authReducer,
  chatReducer,
  journeyReducer,
  bookingReducer,
  socialReducer,
  adminReducer,
});

export default rootReducer;
